"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
let EnterpriseVerify = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.is_checked = false;
    this.model_status = 0;
    this.detmain_company = "";
    this.date_time = 0;
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.getCertification();
    });
  }
  getCertification() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v7/certification`);
        console.log(response.data);
        if (response.data.status === 0) {
          this.is_checked = false;
          this.model_status = 0;
          return;
        }
        if (response.data.status === 1) {
          this.is_checked = true;
          this.model_status = 1;
          this.detmain_company = response.data.enterprise_name;
          this.date_time = response.data.passTime;
          return;
        }
        if (response.data.status === 2) {
          this.is_checked = false;
          this.model_status = 2;
          return;
        }
      } catch (e) {
        this.is_checked = false;
      }
    });
  }
  contectus() {
    window.open("https://www.kuajingvs.com/contact", "_blank");
  }
  openVerify() {
    window.open("https://eca.kuajingvs.com/", "_blank");
  }
  // async getAccountPrivilege(){
  //     try {
  //         const response = await API.get("api://base.auth/api/v7/accounts/privilege")
  //         this.privilege = response.data
  //     } catch (error:any) {
  //         if (error.hasOwnProperty('response')) {
  //             this.$message.error(error.response.data.errors.datas[0].message);
  //         }
  //     }
  // }
};
EnterpriseVerify = __decorateClass([
  Component({
    components: {}
  })
], EnterpriseVerify);
export {
  EnterpriseVerify as default
};
